import { AxiosResponse } from 'axios';
import apiInterceptor from '../utils/axios';
import { ResponseApi } from '../types/Response/ResponseApi';
import { FacultadPos } from '../types/Postgrado/Postgrado';

const SERV_BACK: string = process.env.REACT_APP_API_ESPOL_ADS || '';
const APICONSULTA = 'api/Catalog/PostGrado/';

export default class PostgradoService {

    static async ConsultaCarrerasProgramas(modo?: string): Promise<ResponseApi<FacultadPos>> {
        const url = `${SERV_BACK}${APICONSULTA}ConsultaCarrerasProgramas${modo ? `?modo=${modo}` : ''}`;
        const response1: AxiosResponse<ResponseApi<FacultadPos>> = await apiInterceptor.get(url,
            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );
        return response1.data;
    }

}